import React from 'react';
import { AuthProvider } from './component/authentication/AuthContext';
import {BrowserRouter as Router, Route, Routes, useLocation} from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import EmploymentFormContainer from "./institute/EmploymentFormContainer";
import WelcomePage from "./component/WelcomePage";
import Overview from "./component/Overview";
import DetailCard from "./component/DetailCard";
import OverviewPage from "./component/OverviewPage";
import ProtectedRoute from "./ProtectedRoute";
import ContractContainerPage from "./staff/ContractContainerPage";
import EmployeeFormContainer from "./hr/EmployeeFormContainer";
import StaffMemberDashboard from "./staff/StaffMemberDashboard";
import Header from "./component/ui/Header";
import Footer from "./component/ui/Footer";
import LogoutForm from "./component/authentication/LogoutForm";
import HRDashboard from "./hr/HRDashboard";
import InstituteDashboard from "./institute/InstituteDashboard";
import {PersistGate} from "redux-persist/integration/react";
import {Provider} from "react-redux";
import { store, persistor } from './redux/store';
import {ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import RoleSelectorModal from "./component/RoleSelectorModal";
import RectorateDashboard from "./rectorate/RectorateDashboard";
import RectorateStatistics from "./rectorate/RectorateStatistics";
import SchoolDashboard from "./school/SchoolDashboard";
import FederalStateDashboard from "./federalstate/FederalStateDashboard";

function App() {
    return (
        <div className="App">
            <Provider store={store}>
                <PersistGate loading={null} persistor={persistor}> {/* PersistGate hier verwenden */}
                    <AuthProvider>
                        <Router>
                            <Header/>
                            <RoleSelectorWrapper />
                            <div className="content">
                            <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false}
                                            newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable
                                            pauseOnHover/>
                            <Routes>
                                <Route exact path="/logout" element={<LogoutForm/>}/>
                                <Route exact path="/" element={<WelcomePage/>}/>
                                <Route path="/mdb/" element={
                                    <ProtectedRoute allowedRoles={['staffmembers']}>
                                        <OverviewPage/>
                                    </ProtectedRoute>
                                }/>
                                <Route path="/mdb/staff/" element={
                                    <ProtectedRoute allowedRoles={['staffmembers']}>
                                        <StaffMemberDashboard/>
                                    </ProtectedRoute>
                                }/>
                                <Route path="/mdb/staff/contracts" element={
                                    <ProtectedRoute allowedRoles={['staffmembers']}>
                                        <Overview/>
                                    </ProtectedRoute>
                                }/>
                                <Route path="/mdb/staff/contract/:id?" element={
                                    <ProtectedRoute allowedRoles={['staffmembers', 'humanressource', 'assistant', 'institute']}>
                                        <ContractContainerPage/>
                                    </ProtectedRoute>
                                }/>
                                <Route path="/mdb/hr" element={
                                    <ProtectedRoute allowedRoles={['humanressource']}>
                                        <HRDashboard/>
                                    </ProtectedRoute>
                                }/>
                                <Route path="/mdb/hr/overview" element={
                                    <ProtectedRoute allowedRoles={['humanressource']}>
                                        <Overview/>
                                    </ProtectedRoute>
                                }/>
                                <Route path="/mdb/hr/overview/detail" element={
                                    <ProtectedRoute allowedRoles={['humanressource']}>
                                        <DetailCard entries=""/>
                                    </ProtectedRoute>
                                }/>
                                <Route path="/mdb/institute/employment/new" element={
                                    <ProtectedRoute allowedRoles={['assistant','institute']}>
                                        <EmployeeFormContainer/>
                                    </ProtectedRoute>
                                }/>
                                <Route path="/mdb/institute/employment/details/:id" element={
                                    <ProtectedRoute allowedRoles={['assistant','institute']}>
                                        <EmploymentFormContainer/>
                                    </ProtectedRoute>
                                }/>
                                <Route path="/mdb/institute" element={
                                    <ProtectedRoute allowedRoles={['assistant','institute']}>
                                        <InstituteDashboard/>
                                    </ProtectedRoute>
                                }/>
                                <Route path="/mdb/institute/overview" element={
                                    <ProtectedRoute allowedRoles={['assistant','institute']}>
                                        <Overview/>
                                    </ProtectedRoute>
                                }/>
                                <Route path="/mdb/rectorate" element={
                                    <ProtectedRoute allowedRoles={['rectorate']}>
                                        <RectorateDashboard/>
                                    </ProtectedRoute>
                                }/>
                                <Route path="/mdb/rectorate/overview" element={
                                    <ProtectedRoute allowedRoles={['rectorate']}>
                                        <Overview/>
                                    </ProtectedRoute>
                                }/>
                                <Route path="/mdb/rectorate/statistics" element={
                                    <ProtectedRoute allowedRoles={['rectorate']}>
                                        <RectorateStatistics/>
                                    </ProtectedRoute>
                                }/>
                                <Route path="/mdb/school" element={
                                    <ProtectedRoute allowedRoles={['school']}>
                                        <SchoolDashboard/>
                                    </ProtectedRoute>
                                }/>
                                <Route path="/mdb/school/overview" element={
                                    <ProtectedRoute allowedRoles={['school']}>
                                        <Overview/>
                                    </ProtectedRoute>
                                }/>
                                <Route path="/mdb/federalstate" element={
                                    <ProtectedRoute allowedRoles={['federalstate']}>
                                        <FederalStateDashboard/>
                                    </ProtectedRoute>
                                }/>
                                <Route path="/mdb/federalstate/overview" element={
                                    <ProtectedRoute allowedRoles={['federalstate']}>
                                        <Overview/>
                                    </ProtectedRoute>
                                }/>
                                <Route path="/mdb/admin" element={
                                    <ProtectedRoute allowedRoles={['admin']}>
                                        <EmploymentFormContainer/>
                                    </ProtectedRoute>
                                }/>
                                <Route path="/mdb/role/" element={
                                    <ProtectedRoute allowedRoles={['staffmembers', 'assistant', 'institute', 'school', 'federalstate', 'rectorate', 'admin']}>
                                        <RoleSelectorModal/>
                                    </ProtectedRoute>
                                }/>
                            </Routes>
                            </div>
                            <Footer/>
                        </Router>
                    </AuthProvider>
                </PersistGate>
            </Provider>
        </div>
    );
}

function RoleSelectorWrapper() {
    const location = useLocation();
    return (
        <>
            {location.pathname !== '/logout' && location.pathname !== '/' && <RoleSelectorModal />}
        </>
    );
}

export default App;
